export const ADS_PADDING_WITHOUT_TITLE = 5;
